import { useLocation } from 'react-router-dom';
import { shapeForPath, type ShapePose, type ShapeTone } from '../lib/shapes';
import { stripLocale } from '../lib/localePath';

export function ShapeAccent({ pose, tone = 'accent' }: { pose: ShapePose; tone?: ShapeTone }) {
  return (
    <div
      aria-hidden
      className={`shape-accent shape-accent--${tone}`}
      style={{ ['--shape' as string]: `url(/brand/shapes/${pose}.png)` }}
    />
  );
}

export function RouteShapeAccent() {
  const { pathname } = useLocation();
  const spec = shapeForPath(stripLocale(pathname));
  if (!spec) return null;
  return <ShapeAccent pose={spec.pose} tone={spec.tone} />;
}
